var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"custom-btn custom-btn--back",attrs:{"text":"","color":"secondary"},on:{"click":_vm.navigateBack}},[_c('v-img',{attrs:{"src":require("@/assets/img/icons/chevron.svg")}}),_vm._v(" Back ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }